export default __webpack_public_path__ + "static/media/logo-mind-inventory-w.8514e2e8.svg";